import { useField } from 'formik';
import { DetailedHTMLProps, InputHTMLAttributes } from 'react';


function FormCheckBox({ value, type, ...otherProps }: DetailedHTMLProps<InputHTMLAttributes<HTMLInputElement>, HTMLInputElement>) {
    const [field] = useField(otherProps as any);

    return (
        <label className='text-xl cursor-pointer'>
            <input type="checkbox" className='hidden peer' {...field} {...otherProps} value={value} />
            <i className="peer-checked:hidden ri-checkbox-blank-line"></i>
            <i className="hidden peer-checked:inline ri-checkbox-line"></i>
        </label>
    );
}


export default FormCheckBox;